import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@/core/ui';
import { MenuItem as ProSidebarMenuItem } from 'react-pro-sidebar';
import { useLocation } from 'react-router-dom';
import { SidebarMenuItemLink } from './SidebarMenuItemLink';
const SidebarMenuItem = ({ linkTo, icon, title, active, collapsed }) => {
    const { pathname } = useLocation();
    return (_jsx(ProSidebarMenuItem, { style: { position: 'relative' }, component: _jsx(SidebarMenuItemLink, { collapsed: collapsed, to: linkTo, title: title }), icon: _jsx(SvgIcon, { icon: icon, size: "xl" }), prefix: true, 
        // TODO: later. Currently there is a warning in console:
        // "Failed prop type: Invalid prop `children` of type `array` supplied to `ForwardRef(Tooltip)`, expected a
        // single ReactElement."
        // To remove it ProSidebarMenuItem must have `label` prop (like `icon` prop) that is possible to be removed.
        // {...(collapsed ? { label: <div className="label-omg"></div> } : {})}
        active: active ?? pathname.startsWith(typeof linkTo === 'string' ? linkTo : (linkTo.pathname ?? '')), children: title }));
};
export { SidebarMenuItem };
